import { render, staticRenderFns } from "./VistaGestorUsuarios.vue?vue&type=template&id=61409809&scoped=true"
import script from "./VistaGestorUsuarios.vue?vue&type=script&lang=js"
export * from "./VistaGestorUsuarios.vue?vue&type=script&lang=js"
import style0 from "./VistaGestorUsuarios.vue?vue&type=style&index=0&id=61409809&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61409809",
  null
  
)

export default component.exports